import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import FormControl  from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';

import { withStyles } from '@material-ui/core/styles';
import {  observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Redirect } from 'react-router-dom'
import {pending, error} from '../stores/State'
import Button from '@material-ui/core/Button';

@inject('store')
@observer
class Login extends Component {

login(){
    const uiStore = this.props.store.loginUIStore;
    const store = this.props.store.userStore;
    
    store.login(uiStore.username, uiStore.password);
}

componentWillMount(){
    const uiStore = this.props.store.loginUIStore;
    uiStore.reset();    
}

handleSubmit(event){
    event.preventDefault()
    this.login()
}

render() {    
    const { classes } = this.props;
    const store = this.props.store.userStore;
    const uiStore = this.props.store.loginUIStore;
    
    if(store.isAuthenticated){
        return (
        <Redirect to={{ pathname: '/accounts' }}/>
        );
    }

    return (
        <Grid container className={classes.content} justify='center' alignItems='center' spacing={24}>
            <Grid item xs={12} sm={6} className={classes.loginCard}>
                <Paper className={classes.paper}>
                    <Typography variant="title">Sign in</Typography>
                    <form onSubmit={this.handleSubmit.bind(this)}>
                        <FormControl fullWidth={true}>
                            <InputLabel htmlFor="username">Username</InputLabel>
                            <Input type="text" id="username" value={uiStore.username} onChange={(event)=>uiStore.setUsername(event.target.value)} />
                        </FormControl>

                        <FormControl fullWidth={true}>
                            <InputLabel htmlFor="password">Password</InputLabel>
                            <Input type="password" id="password" value={uiStore.password} onChange={(event)=>uiStore.setPassword(event.target.value) } />
                        </FormControl>

                        <Button type="submit" variant="contained" color="primary" className={classes.loginButton}>Sign in</Button>
                        {store.loginState === pending && <CircularProgress />}
                        {store.loginState === error && <Typography color='error' type="body1">Login failed. Please check your username and password.</Typography>}
                    </form>
                </Paper>
            </Grid>
        </Grid>
    );
  }
}
const styles = theme => ({
    paper:{
        padding: 30
    },
    content: {
         
    },
    loginCard:{
        height: 200,
    },
    loginButton:{
        marginTop: 30
    }
});

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js